import { useParams, useLocation } from 'react-router-dom';
import { VisitScreen as ClinicalVisit } from '@parsina/framework/clinical';

// /visit/:patientId — the doctor panel's ROUTE onto the shared visit room.
//
// The room itself lives in @parsina/framework/clinical, the same code the clinic
// panel renders for a manager who also sees patients (docs/CLINICAL_KIT_DESIGN.md).
// All this file owns is reading the address: the id is authoritative, and
// whatever the caller put in `location.state` (the patient's name, the
// appointment it came from) rides along exactly as it always did.
const VisitScreen = () => {
  const { patientId } = useParams();
  const { state } = useLocation();
  return <ClinicalVisit patient={state || { id: patientId }} />;
};

export default VisitScreen;
